import { Form, notification } from 'antd';
import { useChangePasswordMutation } from '@/state/slices/users';

interface PasswordFormValues {
  currentPassword: string;
  newPassword: string;
  confirmNewPassword: string;
}

export function useChangePassword() {
  const [pwForm] = Form.useForm<PasswordFormValues>();
  const [changePassword, { isLoading: changingPassword }] =
    useChangePasswordMutation();

  const onChangePassword = async () => {
    try {
      const values = await pwForm.validateFields();

      await changePassword({
        currentPassword: values.currentPassword,
        newPassword: values.newPassword,
      }).unwrap();

      pwForm.resetFields();

      notification.success({
        message: 'Password updated',
        description: 'Your password was changed successfully.',
        placement: 'bottomRight',
      });
    } catch {
      notification.error({
        message: 'Password change failed',
        description: 'Could not update password. Please try again.',
        placement: 'bottomRight',
      });
    }
  };

  return { pwForm, changingPassword, onChangePassword };
}
